import { createFetcher } from "@goodfill/backend-api-client";

const baseUrl = import.meta.env.VITE_BACKEND_BASE_URL;

export const backendFetcher = createFetcher(baseUrl);
